import React, { useEffect, useState } from 'react';

export const DEFAULT_AVATAR_URI = '/resources/blank-user-avatar.png';

/**
 * Avatar for a deck's author, hotlinked from whichever site the deck was
 * imported from — so it fails in ways we don't control.
 *
 * `no-referrer` is load-bearing, not hygiene: static.mythichub.com sits behind
 * hotlink protection that answers 403 to any request carrying a cross-origin
 * Referer and 200 to one carrying none, so without it every MythicHub avatar
 * breaks. Anything still broken after that drops to the default rather than
 * leaving the browser's torn-image glyph on the page.
 *
 * Pass `renderFallback` to substitute your own markup instead of the default
 * image when there's nothing to show.
 */
export function AuthorAvatar({ avatarUrl, alt, renderFallback, ...imgProps }) {
    const [failed, setFailed] = useState(false);

    // List rows recycle as the user pages, so reset on a new URL — otherwise one
    // dead avatar pins the fallback onto every author that reuses the slot.
    useEffect(() => setFailed(false), [avatarUrl]);

    const isBroken = failed || !avatarUrl;
    if (isBroken && renderFallback) {
        return renderFallback();
    }

    return (
        <img
            {...imgProps}
            src={isBroken ? DEFAULT_AVATAR_URI : avatarUrl}
            alt={alt || 'avatar'}
            referrerPolicy="no-referrer"
            onError={() => setFailed(true)}
        />
    );
}
